import { render, staticRenderFns } from "./ManageCommission.vue?vue&type=template&id=bd3a4c58&scoped=true"
import script from "./ManageCommission.vue?vue&type=script&lang=js"
export * from "./ManageCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3a4c58",
  null
  
)

export default component.exports